import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-60ddf7d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row my-2 text-gray-400 items-center" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-row my-2 text-gray-400 items-center"
};
const _hoisted_3 = {
    key: 2,
    style: { "display": "flex", "align-items": "center" },
    class: "mt-2"
};
const _hoisted_4 = { style: { "margin-left": "10px" } };
const _hoisted_5 = {
    key: 0,
    style: { "margin-left": "10px" }
};
const _hoisted_6 = { class: "flex flex-col my-2 text-gray-400" };
const _hoisted_7 = { class: "min-w-4" };
const _hoisted_8 = { class: "flex flex-col my-2 text-gray-400" };
const _hoisted_9 = {
    key: 4,
    class: "grid grid-cols-2 gap-2 my-2 items-center"
};
const _hoisted_10 = { class: "grid" };
import { appState } from '@/composable/appState';
import config from '@/config';
import { CHAT_WIDGET_IDS, ChatBubbleType, ChatWidgetSettingsDataOptions, WidgetPositionOptions, } from '@/helper/const';
import { updateChatWidgetSetting } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { InfoCircleIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIAvatar, UIDivider, UIFormItem, UIInput, UIInputNumber, UIRadio, UIRadioGroup, UIRadioGroupItem, UISpace, UISwitch, UITextXsRegular, UITooltip, } from '@gohighlevel/ghl-ui';
import { ref, watchEffect } from 'vue';
import MediaUpload from '../../../MediaUpload.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WidgetCustomization',
    setup(__props) {
        const DEPLOYMENT_BASE_URL = config.DEPLOYMENT_URL;
        const DEFAULT_AVATAR_IMAGE = `${DEPLOYMENT_BASE_URL}chat-widget/assets/defaultAvatar.png`;
        const openMediaPicker = ref(false);
        const imageUrl = ref();
        const widgetCustomizationTypeSelected = ref();
        const widgetCustomizationType = ref([
            {
                value: 'auto',
                label: i18n.global.t('sidebar.auto'),
                helper: i18n.global.t('sidebar.autoWidgetHelper'),
            },
            {
                value: 'custom',
                label: i18n.global.t('sidebar.custom'),
                helper: i18n.global.t('sidebar.customWidgetHelper'),
            },
        ]);
        const handleWidgetCustomizationTypeChange = (e) => {
            widgetCustomizationTypeSelected.value = e.target.value;
            if (e.target.value === 'custom') {
                appState.chatWidgetSettingsData.dimensions.sizes.height = 625;
                appState.chatWidgetSettingsData.dimensions.sizes.width = 340;
            }
            else {
                appState.chatWidgetSettingsData.dimensions.sizes.height = '';
                appState.chatWidgetSettingsData.dimensions.sizes.width = '';
            }
            appState.unsavedChanges = true;
        };
        const handleEdit = () => (openMediaPicker.value = true);
        const closeMediaPicker = () => (openMediaPicker.value = false);
        const updateWidgetPosition = (val) => {
            appState.chatWidgetSettingsData.dimensions.position = val;
            appState.unsavedChanges = true;
        };
        const updateWidgetWidth = (val) => {
            if (val < 340) {
                appState.chatWidgetSettingsData.dimensions.sizes.width = 340;
            }
            else
                appState.chatWidgetSettingsData.dimensions.sizes.width = val;
            appState.unsavedChanges = true;
        };
        const updateWidgetHeight = (val) => {
            if (val < 625) {
                appState.chatWidgetSettingsData.dimensions.sizes.height = 625;
            }
            else
                appState.chatWidgetSettingsData.dimensions.sizes.height = val;
            appState.unsavedChanges = true;
        };
        const updatePromptAvatar = (val) => {
            if (val) {
                imageUrl.value = val;
                appState.chatWidgetSettingsData.promptAvatar = imageUrl.value;
                imageUrl.value = '';
                appState.unsavedChanges = true;
            }
        };
        const handleReplaceImage = () => {
            appState.chatWidgetSettingsData.promptAvatar = DEFAULT_AVATAR_IMAGE;
            appState.unsavedChanges = true;
        };
        const updateChatWidgetAllowAvatarImage = (val) => {
            appState.chatWidgetSettingsData.allowAvatarImage = val;
            if (appState.chatWidgetSettingsData.allowAvatarImage === false) {
                appState.chatWidgetSettingsData.promptType = ChatBubbleType.NORMAL;
            }
            else {
                appState.chatWidgetSettingsData.promptType = ChatBubbleType.AVATAR;
            }
            appState.unsavedChanges = true;
        };
        watchEffect(() => {
            const { dimensions } = appState.chatWidgetSettingsData;
            const { sizes } = dimensions;
            if (sizes.height === null ||
                sizes.height === '' ||
                sizes.width === null ||
                sizes.width === '') {
                widgetCustomizationTypeSelected.value = 'auto';
            }
            else {
                widgetCustomizationTypeSelected.value = 'custom';
                sizes.height = sizes.height || 625;
                sizes.width = sizes.width || 340;
            }
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(UISwitch), {
                        rubberBand: false,
                        value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.allowAvatarImage,
                        "onUpdate:value": _cache[0] || (_cache[0] = val => updateChatWidgetAllowAvatarImage(val))
                    }, null, 8 /* PROPS */, ["value"]),
                    _createVNode(_unref(UIFormItem), {
                        label: _ctx.$t('sidebar.allowAvatarImage'),
                        "show-feedback": false,
                        class: "pl-2 pt-2"
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                (((_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.allowAvatarImage) &&
                    !((_d = (_c = _unref(appState).chatWidgetSettingsData) === null || _c === void 0 ? void 0 : _c.promptAvatar) === null || _d === void 0 ? void 0 : _d.includes('/chat-widget/assets/defaultAvatar.png')))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_unref(UISwitch), {
                            rubberBand: false,
                            value: (_e = _unref(appState).chatWidgetSettingsData) === null || _e === void 0 ? void 0 : _e.isPromptAvatarImageOptimize,
                            "onUpdate:value": _cache[1] || (_cache[1] =
                                val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).IS_PROMPT_AVATAR_IMAGE_OPTIMIZE, val))
                        }, null, 8 /* PROPS */, ["value"]),
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.imageOptimization'),
                            "show-feedback": false,
                            class: "pl-2 pt-2"
                        }, null, 8 /* PROPS */, ["label"]),
                        _createVNode(_unref(UITooltip), {
                            trigger: "hover",
                            width: "250px",
                            placement: "right"
                        }, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-4" })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.imageOptimizationHelper')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true),
                (((_f = _unref(appState).chatWidgetSettingsData) === null || _f === void 0 ? void 0 : _f.allowAvatarImage) === true)
                    ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                        key: 1,
                        class: "mt-1 text-gray-400"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.allowAvatarImageHelper')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true),
                (((_g = _unref(appState).chatWidgetSettingsData) === null || _g === void 0 ? void 0 : _g.allowAvatarImage) === true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_unref(UIAvatar), {
                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_AVATAR,
                            size: 40,
                            objectFit: "fill",
                            round: true,
                            src: (_h = _unref(appState).chatWidgetSettingsData) === null || _h === void 0 ? void 0 : _h.promptAvatar
                        }, null, 8 /* PROPS */, ["id", "src"]),
                        _createElementVNode("span", _hoisted_4, [
                            _createVNode(_unref(UITextXsRegular), {
                                role: "button",
                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_MEDIA_UPLOADER,
                                class: "text-error-500 cursor-pointer",
                                onClick: handleEdit
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.replace')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["id"])
                        ]),
                        (((_j = _unref(appState).chatWidgetSettingsData) === null || _j === void 0 ? void 0 : _j.promptAvatar) !== DEFAULT_AVATAR_IMAGE)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _createVNode(_unref(UITextXsRegular), {
                                    role: "button",
                                    onClick: handleReplaceImage,
                                    class: "text-error-500 cursor-pointer"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.remove')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]))
                    : _createCommentVNode("v-if", true),
                (((_k = _unref(appState).chatWidgetSettingsData) === null || _k === void 0 ? void 0 : _k.allowAvatarImage) === true)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 3,
                        label: _ctx.$t('sidebar.altText'),
                        "show-feedback": false,
                        class: "pt-3"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    type: "text",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.promptAvatarAltText,
                                    placeholder: _unref(i18n).global.t('placeholder.promptAvatarAltText'),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).PROMPT_AVATAR_ALT_TEXT, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(UIDivider)),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.widgetPosition'),
                            "show-feedback": false
                        }, {
                            default: _withCtx(() => {
                                var _a, _b;
                                return [
                                    _createVNode(_unref(UIRadioGroup), {
                                        value: (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.dimensions) === null || _b === void 0 ? void 0 : _b.position,
                                        name: "WidgetPositionOptions",
                                        "onUpdate:value": _cache[3] || (_cache[3] = val => updateWidgetPosition(val))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(UISpace), { justify: "space-evenly" }, {
                                                default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WidgetPositionOptions), (item) => {
                                                        return (_openBlock(), _createBlock(_unref(UIRadioGroupItem), {
                                                            key: item.value,
                                                            value: item.value,
                                                            compact: true
                                                        }, {
                                                            icon: _withCtx(() => [
                                                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-14 h-14" }))
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["value"])
                                ];
                            }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"])
                    ]),
                    _createVNode(_unref(UITextXsRegular), { class: "mt-1" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.widgetPositionHelper')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(_unref(UIDivider)),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(UIFormItem), {
                        label: _ctx.$t('sidebar.widgetDimension'),
                        "show-feedback": false
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIRadioGroup), {
                                value: widgetCustomizationTypeSelected.value,
                                name: "widget-customization-type",
                                id: "pg-chat-widget-widget-customization-type",
                                class: "radio-button"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(widgetCustomizationType.value, (option) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: option.value
                                        }, [
                                            _createVNode(_unref(UIRadio), {
                                                id: "pg-chat-widget-widget-customization-type-radio-button",
                                                value: option.value,
                                                label: option.label,
                                                onChange: handleWidgetCustomizationTypeChange
                                            }, null, 8 /* PROPS */, ["value", "label"]),
                                            (!!option.helper)
                                                ? (_openBlock(), _createBlock(_unref(UITooltip), {
                                                    key: 0,
                                                    trigger: "hover",
                                                    placement: "top"
                                                }, {
                                                    trigger: _withCtx(() => [
                                                        _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-6 pr-2 mr-4 text-black" })
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createElementVNode("span", null, _toDisplayString(option.helper), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */))
                                                : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["value"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"])
                ]),
                (widgetCustomizationTypeSelected.value === 'custom')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.chatWidgetWidth'),
                            "show-feedback": false
                        }, {
                            default: _withCtx(() => {
                                var _a, _b, _c;
                                return [
                                    _createVNode(_unref(UIInputNumber), {
                                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                        modelValue: (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.dimensions) === null || _b === void 0 ? void 0 : _b.sizes) === null || _c === void 0 ? void 0 : _c.width,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = val => updateWidgetWidth(val)),
                                        showButton: false,
                                        min: 340,
                                        placeholder: _unref(i18n).global.t('placeholder.width')
                                    }, {
                                        suffix: _withCtx(() => [
                                            _createTextVNode("PX")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                                ];
                            }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_unref(UIFormItem), {
                                label: _ctx.$t('sidebar.chatWidgetHeight'),
                                "show-feedback": false
                            }, {
                                default: _withCtx(() => {
                                    var _a, _b, _c;
                                    return [
                                        _createVNode(_unref(UIInputNumber), {
                                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                            modelValue: (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.dimensions) === null || _b === void 0 ? void 0 : _b.sizes) === null || _c === void 0 ? void 0 : _c.height,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = val => updateWidgetHeight(val)),
                                            showButton: false,
                                            min: 625,
                                            placeholder: _unref(i18n).global.t('placeholder.height')
                                        }, {
                                            suffix: _withCtx(() => [
                                                _createTextVNode("PX")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                                    ];
                                }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                (_openBlock(), _createBlock(_Teleport, { to: 'body' }, [
                    (openMediaPicker.value)
                        ? (_openBlock(), _createBlock(MediaUpload, {
                            key: 0,
                            allowedExtensions: ['image'],
                            openMediaPicker: openMediaPicker.value,
                            onClose: closeMediaPicker,
                            onChangeUrl: _cache[6] || (_cache[6] = val => updatePromptAvatar(val)),
                            maxUploadSize: 10000000
                        }, null, 8 /* PROPS */, ["openMediaPicker"]))
                        : _createCommentVNode("v-if", true)
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
